import ArticleCardCompact, {
	ArticleCardCompactProps as _ArticleCardCompactProps,
} from './ArticleCardCompact';

export { ArticleCardCompact };
export type ArticleCardCompactProps = _ArticleCardCompactProps;
